import {Component, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {FlowRecipientsComponent} from '../../mail-flow/flow-recipients/flow-recipients.component';
import {IdexService} from 'app/idex.service';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {Toast} from 'app/shared/toast/toast';

declare let $: any;
let message;

@Component({
   selector: 'app-new-workflow',
   templateUrl: './new-workflow.component.html',
   styleUrls: ['./new-workflow.component.css']
})
export class NewWorkflowComponent implements OnInit {
   public typeName = 'workFlow';
   backButton;
   requireInputMessage: string;
   id: number;
   errorMessage: any;
   title: string;
   mode: string;
   wfNameValue: any = '';
   error: any;
   public taskAttribute = {
      taskId: 0,
      taskName: '',
      dueDate: '',
      priority: '',
      templateId: '',
      workflowId: '',
      currentLevel: 1,
      apvLevel: [],
      docList: [],
      message: '',
      viewMode: null
   };

   @ViewChild(FlowRecipientsComponent, {static: true}) flowRec: FlowRecipientsComponent;

   constructor(private translate: TranslateService,
               public service: IdexService,
               private dialogRef: MatDialogRef<NewWorkflowComponent>,
               public toast: Toast) {
   }

   ngOnInit() {
      if (!this.taskAttribute.viewMode) {
         this.translate.get('cancel').subscribe((msg) => {
            this.backButton = msg;
            this.flowRec.isDrag = true;
         });
      } else {
         this.translate.get('signOff.close').subscribe((msg) => {
            this.backButton = msg;
            this.flowRec.isDrag = false;
         });
      }
      let headTitle = 'workflow.new';
      if (this.mode === 'edit' && !this.taskAttribute.viewMode) {
         headTitle = 'workflow.edit';
      }
      if (this.mode === 'edit' && this.taskAttribute.viewMode) {
         this.translate.get('workflow.workflow').subscribe((msg) => {
            headTitle = msg;
         });
      }

      this.translate.get(headTitle).subscribe(s => {
         this.title = s;
      });

      this.translate.get('alert.inputRequired').subscribe((msg) => {
         this.requireInputMessage = msg;
         message = msg;
      });
      this.InvalidMsg();
   }

   InvalidMsg() {
      $('#form input[type=text]').on('change invalid', function () {
         const textfield = $(this).get(0);
         const contactName = textfield.value.trim();
         textfield.setCustomValidity('');
         if (contactName === '') {
            textfield.setCustomValidity(message);
            setTimeout(function () {
               textfield.setCustomValidity(' ');
            }, 1000);
         }
      });
   }

   getWorkflow() {
      this.service.getWorkflow(this.id)
         .subscribe((data) => {
            this.flowRec.taskAttribute.apvLevel = data.apvLevel;
         }, error => {
            this.errorMessage = error;
         });
   }

   saveWorkflow(wfName: any) {
      const value = wfName.value.trim();
      if (/[<|>\\\/:?*"%^{}[\]]/g.test(value)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
         return;
      }
      if (this.id === undefined) {
         this.id = 0;
      }
      let isNotHaveSigner = false;
      let isRequireNoOfSigner = false;
      let messList = '';

      if (this.flowRec.taskAttribute.apvLevel.length === 0) {
         this.handleToastError('newWorkFlow.errorAddRecipient');
         return;
      }

      for (let i = 0; i < this.flowRec.taskAttribute.apvLevel.length; i++) {
         if (this.flowRec.taskAttribute.apvLevel[i].signerList.length === 0) {
            isNotHaveSigner = true;
            if (messList !== '') {
               messList += ', ';
            }
            messList += (i + 1);
         } else if (this.flowRec.taskAttribute.apvLevel[i].numOfSigner === 0) {
            for (let j = 0; j < this.flowRec.taskAttribute.apvLevel[i].signerList.length; j++) {
               if (this.flowRec.taskAttribute.apvLevel[i].signerList[j].action.toLowerCase() === 'need to sign') {
                  isRequireNoOfSigner = true;
                  if (messList !== '') {
                     messList += ', ';
                  }
                  messList += (i + 1);
                  break;
               }
            }
         }
      }

      if (isNotHaveSigner) {
         this.handleToastError('newWorkFlow.errorAddRecipientOrder', messList);
         return;
      } else if (isRequireNoOfSigner) {
         this.handleToastError('newWorkFlow.errorSelectRecipientOrder', messList);
         return;
      }

      this.service.saveWorkflow(this.id, wfName.value, this.flowRec.taskAttribute.apvLevel)
         .subscribe((response) => {
            this.dialogRef.close(true);
            this.toast.success(response);
         }, error => {
            this.errorMessage = error;
         });
   }

   handleToastError(key, msgList?) {
      this.translate.get(key).subscribe((msg) => {
         if (msgList) {
            this.toast.error(msg + msgList);
         } else {
            this.toast.error(msg);
         }
      });
   }
}
